var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sections"},[_vm._l((_vm.displaySections),function(section,index){return [(section.type == 'image_set')?[_c('image-set',{key:index,attrs:{"section":section}})]:_vm._e(),_vm._v(" "),(section.type == 'section')?[_c('text-section',{key:index,attrs:{"section":section}})]:_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd12614","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sections.vue
// module id = null
// module chunks = 